export default "__VITE_ASSET__DExKOiBj__"